module.exports = __webpack_public_path__ + "img/icon_repositorio_unico.83264f4c.png";